namespace $ {

	export class $shm_hitalama_map_history_targets extends $giper_baza_dict_to(
		$shm_hitalama_map_history_target_events,
	) {}

}
